export var componentsLocales = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  dayCellChooseDateAriaLabel: 'Choose date'
};